import { TmTransportError } from '@/core/error/transport/tmTransportError'

export class TmStorageError extends TmTransportError {
  public name = 'TmStorageError'
}
